import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Optional, Output, SkipSelf} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {BlockStore} from '../block/block.store';
import {distinctUntilChanged, filter, map} from 'rxjs/operators';
import {combineLatest, Subscription} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {BLOCKS_CONFIG, BlocksConfig} from '../blocks.config';
import {SessionControllerService} from '../../submission/src/app/session/session-controller.service';
import {Button} from '@paperlessio/sdk/api/models';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit, OnDestroy {

  @Input() block: Button;
  @Input() customClickHandler = false;
  @Output() clickHandler: EventEmitter<any> = new EventEmitter<any>();
  page;

  subs = new Subscription();

  constructor(public sanitizer: DomSanitizer,
              private http: HttpClient,
              public route: ActivatedRoute,
              private blockStore: BlockStore,
              @Inject(BLOCKS_CONFIG) public blocksConfig: BlocksConfig,
              @SkipSelf() @Optional() public sessionController: SessionControllerService,) {
  }

  ngOnInit() {
    if (!this.blocksConfig.editable) {
      const params = this.route.params.pipe(filter(x => !!x.page), distinctUntilChanged());
      const pages = this.blockStore.pages().pipe(distinctUntilChanged());
      this.subs.add(
        combineLatest([params, pages])
          .pipe(map(res => ({params: res[0], pages: res[1]})), distinctUntilChanged())
          .subscribe(result => {
            this.page = result.pages[+result.params.page - 1];
          })
      );
    }
  }

  onClick(event) {
    if (this.customClickHandler) {
      this.clickHandler.emit(event);
      event.preventDefault();
    } else if (this.blocksConfig.interactive && this.sessionController) {
      this.sessionController.goToNextPage();
    } else {
      event.preventDefault();
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

}
